<template>
  <div>
    <Header :title="'応募者管理'" />
    <div
      class="boss-admin-container clearfix"
    >
      <sidebar />
      <keep-alive :include="whiteList">
        <router-view />
      </keep-alive>
    </div>
  </div>
</template>

<script>
import Header from '@/components/templates/Header'
import Sidebar from '@/components/organisms/Sidebar'
import { mapActions } from 'vuex'
import _ from 'lodash'

export default {
  components: {
    Sidebar,
    Header
  },
  data () {
    return {
      whiteList: ['EntryTop']
    }
  },
  created () {
    _([
      'genders',
      'evaluations',
      'prefectures',
      'occupations',
      'businesses',
      'employmentStatuses',
      'educationalBackgrounds',
      'languageSkills',
      'interviewContents',
      'skills',
      'specialFavors',
      'remindStatuses'
    ]).forEach(key => {
      this.storeMaster(key)
    })

    _([
      'phases',
      'statuses',
      'fixedStatuses',
      'allStatuses'
    ]).forEach(key => {
      this.storeSetting(key)
    })
    this.storeResponsibleSetting('responsibles')
  },
  methods: {
    ...mapActions([
      'storeMaster'
    ]),
    ...mapActions('settings', [
      'storeSetting',
      'storeResponsibleSetting'
    ])
  }
}
</script>
